var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.218 1.27h2.249L9.553 6.885l5.78 7.642h-4.526L7.263 9.892l-4.056 4.635H.957L6.211 8.52.667 1.27h4.64l3.205 4.236zm-.79 11.91h1.246L4.63 2.546H3.293z"
  })));
};
export default SvgTwitter;